import React from 'react'
import {NavigationDots, SocialMedia} from '../components'
import { useTheme } from '../context/ThemeContext'

const AppWrap = (Component, idName, className) => function HOC(){
  const {theme} = useTheme()
  return (
    <div id={idName} className={`app__container ${theme ? className : className === 'app__whitebg' ? 'app__darkbg' : 'app__primarydarkbg' }`}>
        <SocialMedia />

        <div className="app__wrapper app__flex">
            <Component/>

        </div>

        <NavigationDots active={idName} />
    </div>
  )
}

export default AppWrap